import { isMatch } from './isMatch';
/**
 * Return the status of the modifiers that matches the given date.
 */
export function getModifierStatus(date, 
/** The modifiers to match for the given date. */
modifiers) {
    var modifiersList = Object.keys(modifiers).reduce(function (previousValue, key) {
        var modifier = modifiers[key];
        if (isMatch(date, modifier)) {
            previousValue.push(key);
        }
        return previousValue;
    }, []);
    var modifiersStatus = {};
    modifiersList.forEach(function (modifier) { return (modifiersStatus[modifier] = true); });
    return modifiersStatus;
}
//# sourceMappingURL=getModifierStatus.js.map